
import { PRIMARY_COLOR, COMMON_TEXT_COLOR, GRAY_BG_COLOR, WHITE_TEXT_COLOR } from '../constants';

export const body = {
    color: COMMON_TEXT_COLOR,
    backgroundColor: GRAY_BG_COLOR,
    fontFamily: 'Arial',
    fontSize: '16px',
    padding: '35px'
};

export const fontWeightBold = {
    fontWeight: '700'
};

export const marginBottom = {
    marginBottom: '6px'
};

export const buttonStyle = {
    margin: 0,
    fontFamily: 'Arial',
    padding: '10px 16px',
    textDecoration: 'none',
    borderRadius: '2px',
    border: '1px solid',
    textAlign: 'center',
    verticalAlign: 'middle',
    fontWeight: 'normal',
    fontSize: '16px',
    whiteSpace: 'nowrap',
    borderColor: PRIMARY_COLOR,
    backgroundColor: PRIMARY_COLOR,
    color: WHITE_TEXT_COLOR,
    borderTopWidth: '1px',
};

export const linkText = {
    color: PRIMARY_COLOR,
    textDecoration: 'none',
    cursor: 'pointer',
};

export const bookingTitle = {
    paddingBottom: '25px',
    fontWeight: 'bold',
    fontSize: '40px',
    lineHeight: '48px',
    margin: '0',
    padding: '0',
    textAlign: 'center'
};

export const center = {
    textAlign: 'center'
};